// The hop from /login to /sign-up, for a visitor who turns out not to have an account yet. It has
// to carry the WorkOS Connect handle or the account they are about to create is never connected.
//
// The leading slash is stripped here rather than by each caller because signUpAction and the
// sign-up page both redirect to `/${redirectAfterRegister}`, where a slash-prefixed value would
// become a protocol-relative URL pointing off-site.
export function buildSignUpHref({
    redirectAfterRegister,
    externalAuthId,
}: {
    redirectAfterRegister?: string;
    externalAuthId?: string;
}): string {
    const params = new URLSearchParams();
    const redirectPath = redirectAfterRegister?.replace(/^\/+/, '');
    if (redirectPath) {
        params.set('redirectAfterRegister', redirectPath);
    }
    if (externalAuthId) {
        params.set('external_auth_id', externalAuthId);
    }

    const query = params.toString();
    return query ? `/sign-up?${query}` : '/sign-up';
}
